<asn-accordion [singleItemOpen]="true">
    <asn-accordion-item
        analyticsClick
        elementType="ACCORDION_ITEM"
        [key]="buttonKey.CALCULATION_DETAILS_BUTTON"
        id="calculationDetailsAccordion"
    >
        <h2 slot="title" class="ap-padding-bottom-2">{{ 'main.calculation-details.title' | apContent }}</h2>
        <ap-notification id="calculationDetailsTip" status="tip"> {{ 'main.calculation-details.tip' | apContent }}</ap-notification>
        <h2 id="closingCostTitle">
            {{ 'main.calculation-details.closing-cost.title' | apContent }}
            <additional-info
                class="text-primary"
                [type]="hintType.ICON"
                [key]="buttonKey.CLOSING_COST_TITLE"
                titleKey="main.calculation-details.closing-cost.additional-info.title"
                contentKey="main.calculation-details.closing-cost.additional-info.content"
            >
            </additional-info>
        </h2>
        <calculation-details-field
            [amount]="closingCostDetails?.transfer_tax_reduced?.amount"
            [originalAmount]="
                closingCostDetails?.transfer_tax?.amount !== closingCostDetails?.transfer_tax_reduced?.amount
                    ? closingCostDetails?.transfer_tax?.amount
                    : 0
            "
            label="main.calculation-details.transfer-tax"
            [additionalInfo]="true"
            [key]="buttonKey.CLOSING_COST_TRANSFER_TAX"
        ></calculation-details-field>
        <calculation-details-field
            [amount]="closingCostDetails?.nhg_premium?.amount"
            label="main.calculation-details.nhg-premium"
            [additionalInfo]="true"
            [key]="buttonKey.CLOSING_COST_NHG"
        ></calculation-details-field>
        <calculation-details-field
            [amount]="closingCostDetails?.notary_delivery_deed?.amount"
            label="main.calculation-details.notary-delivery-deed"
        ></calculation-details-field>
        <calculation-details-field
            [amount]="closingCostDetails?.notary_mortgage_deed?.amount"
            label="main.calculation-details.notary-mortgage-deed"
        ></calculation-details-field>
        <calculation-details-field
            [amount]="closingCostDetails?.advice_handling_mortgage?.amount"
            label="main.calculation-details.advice-handling-mortgage"
        ></calculation-details-field>
        <calculation-details-field
            [amount]="closingCostDetails?.taxation?.amount"
            label="main.calculation-details.taxation"
        ></calculation-details-field>
        <calculation-details-field
            [amount]="closingCostDetails?.bank_guarantee?.amount"
            label="main.calculation-details.bank-guarantee"
            [additionalInfo]="true"
            [key]="buttonKey.CLOSING_COST_BANK_GUARANTEE"
        ></calculation-details-field>
        <hr class="ap-margin-bottom-1" />
        <calculation-details-field
            [amount]="_mortgageCalculation?.closing_cost?.amount?.amount"
            [isSubTotal]="true"
            label="main.calculation-details.closing-cost-total"
        ></calculation-details-field>

        @if (sellingCostDetails) {
            <h2 id="sellingCostTitle">{{ 'main.calculation-details.selling-cost.title' | apContent }}</h2>
            <calculation-details-field
                [amount]="sellingCostDetails?.broker_amount?.amount"
                label="main.calculation-details.broker-amount"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="sellingCostDetails?.cancel_mortgage_deed?.amount"
                label="main.calculation-details.cancel-mortgage-deed"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="sellingCostDetails?.new_energy_label?.amount"
                label="main.calculation-details.new-energy-label"
            ></calculation-details-field>
            <hr class="ap-margin-bottom-1" />
            <calculation-details-field
                [amount]="_mortgageCalculation?.selling_cost?.amount?.amount"
                [isSubTotal]="true"
                label="main.calculation-details.selling-cost-total"
            ></calculation-details-field>
        }

        @if (purchaseCostDetails) {
            <h2 id="purchaseCostTitle">{{ 'main.calculation-details.purchase-cost.title' | apContent }}</h2>
            <calculation-details-field
                [amount]="purchaseCostDetails?.property_amount?.amount"
                label="main.calculation-details.property-amount"
                [additionalInfo]="true"
                [key]="buttonKey.PURCHASE_COST_PROPERTY"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="purchaseCostDetails?.renovation_amount?.amount"
                label="main.calculation-details.renovation-amount"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="purchaseCostDetails?.additional_work_amount?.amount"
                label="main.calculation-details.additional-work-amount"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="purchaseCostDetails?.sustainability_amount?.amount"
                label="main.calculation-details.sustainability-amount"
            ></calculation-details-field>
            <hr class="ap-margin-bottom-1" />
            <calculation-details-field
                [amount]="_mortgageCalculation?.purchase_cost?.amount?.amount"
                [isSubTotal]="true"
                label="main.calculation-details.purchase-cost"
            ></calculation-details-field>
        }

        @if (requiredAssetsDetails) {
            <h2 id="requiredAssetsTitle">{{ 'main.calculation-details.required-assets.title' | apContent }}</h2>
            <calculation-details-field
                [amount]="requiredAssetsDetails?.residual_debt?.amount"
                label="main.calculation-details.residual-debt"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="requiredAssetsDetails?.deficiency_mortgage?.amount"
                label="main.calculation-details.deficiency-mortgage"
                [additionalInfo]="true"
                [key]="buttonKey.REQUIRED_ASSET_DEFICIENCY"
                [additionalInfoParam]="getMortgageDeficiencyInfo()"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="requiredAssetsDetails?.closing_cost?.amount"
                label="main.calculation-details.closing-cost"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="requiredAssetsDetails?.selling_cost?.amount"
                label="main.calculation-details.selling-cost"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="requiredAssetsDetails?.own_investment_renovation_amount?.amount"
                label="main.calculation-details.own-investment-renovation-amount"
                [additionalInfo]="true"
                [key]="buttonKey.REQUIRED_ASSET_OWN_INVESTMENT_RENOVATION"
            ></calculation-details-field>
            <calculation-details-field
                [amount]="requiredAssetsDetails?.own_investment_sustainability_amount?.amount"
                label="main.calculation-details.own-investment-sustainability-amount"
                [additionalInfo]="true"
                [key]="buttonKey.REQUIRED_ASSET_OWN_INVESTMENT_SUSTAINABILITY"
            ></calculation-details-field>
            <hr class="ap-margin-bottom-1" />
            <calculation-details-field
                [amount]="_mortgageCalculation?.required_asset?.amount?.amount"
                [isSubTotal]="true"
                label="main.calculation-details.required-assets-total"
            ></calculation-details-field>
        }

        @if (assetsDetails) {
            <div class="ap-margin-top-2">
                <calculation-details-field
                    [amount]="assetsDetails?.surplus_value?.amount"
                    label="main.calculation-details.surplus-value"
                ></calculation-details-field>
                <calculation-details-field
                    [amount]="assetsDetails?.savings?.amount"
                    label="main.calculation-details.savings"
                ></calculation-details-field>
                <calculation-details-field
                    [amount]="assetsDetails?.required_asset?.amount"
                    label="main.calculation-details.required-assets"
                ></calculation-details-field>
                <hr class="ap-margin-bottom-1" />
                <calculation-details-field
                    [amount]="getAbsTotalAsset()"
                    [isSubTotal]="true"
                    [label]="getTotalAssetLabel()"
                ></calculation-details-field>
            </div>
        }

        <h2 id="resultTitle">{{ 'main.calculation-details.result.title' | apContent }}</h2>

        @if (_mortgageCalculation?.mortgage?.expected_mortgage) {
            <calculation-details-field
                [amount]="_mortgageCalculation?.mortgage?.max_mortgage?.amount"
                label="main.calculation-details.max-mortgage"
            ></calculation-details-field>
            @if (_mortgageCalculation?.asset?.amount?.amount > 0) {
                <calculation-details-field
                    [amount]="_mortgageCalculation?.asset?.amount?.amount"
                    label="main.calculation-details.assets"
                ></calculation-details-field>
            }
            <calculation-details-field
                [amount]="_mortgageCalculation?.mortgage?.expected_mortgage?.amount?.amount"
                [totalRow]="true"
                [isSubTotal]="true"
                label="main.calculation-details.expected-mortgage"
            ></calculation-details-field>
        } @else {
            <calculation-details-field
                [amount]="_mortgageCalculation?.mortgage?.max_mortgage_by_income?.amount?.amount"
                [totalRow]="true"
                [isSubTotal]="true"
                label="main.calculation-details.max-mortgage-by-income"
            ></calculation-details-field>
        }

        @if (_mortgageCalculation?.asset?.amount?.amount > 0) {
            <div class="ap-margin-top-3">
                <ap-notification id="calculationDetailsResultTip" status="success">
                    {{ 'main.calculation-details.result.tip' | apContent }}
                </ap-notification>
            </div>
        }
    </asn-accordion-item>
</asn-accordion>
